// extracted by mini-css-extract-plugin
export default {"nombre":"TablaEstadioNombres_nombre__8JVc7","desde":"TablaEstadioNombres_desde__Znhbn","hasta":"TablaEstadioNombres_hasta__jIwpZ"};